import { debugLevel } from './config';

export function addDebugApis(apis: Record<string, any>) {
  if (!debugLevel) return;
  Object.assign(window, {
    __apis__: {
      // @ts-expect-error __apis__
      ...window.__apis__,
      ...apis,
    },
  });
}
